import { render, staticRenderFns } from "./IsSablonList.vue?vue&type=template&id=9568e89c"
import script from "./IsSablonList.vue?vue&type=script&lang=ts"
export * from "./IsSablonList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports